module.exports = __webpack_public_path__ + "media/images/logo@3x-aca3b237.gif";